
<script>
  /* eslint-disable */
	import { Bar } from 'vue-chartjs'

	export default {
    props: {
      data: {
				required: true, 
				type: Array
			}
		},
		extends: Bar,
	  mounted () {

				if(this.data != undefined)
				{
						this.renderChart({
							datasets: this.data.map(item => {
										return {
													label: item.label,
													fill: false,
													backgroundColor: item.color,
													data: [item.value],
								         
											}
									}),
						},
						{ 
							responsive: true, 
							maintainAspectRatio: false,
							tooltips: {
								enabled: true,
								mode: 'single',
								callbacks: {
									label: function(tooltipItems,data) {
										
										return data.datasets[tooltipItems.datasetIndex].label + ' - R$ ' + tooltipItems.yLabel.toLocaleString('pt-BR', {minimumFractionDigits: "2", maximumFractionDigits: 2}) ;//
									}
								}
							},
							legend: {
								position: 'bottom',
								display: false,
								labels:{
												padding: 15
											}
							},
							scales: {
									yAxes: [{
											display: true,
											ticks: {
													suggestedMin: 0,    // minimum will be 0, unless there is a lower value.
													beginAtZero: true   // minimum value will be 0.
											},
											gridLines: {
														display:false
											}
									}],
								xAxes: [{
											display: true,
											gridLines: {
														display:false
											}
									}]
							}
						});
			}
		},
		methods:{
		}
}
 
</script>





// WEBPACK FOOTER //
// src/components/charts/BarChartInvestimentos.vue